function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0.583252C8.41421 0.583252 8.75 0.919038 8.75 1.33325V3.99992C8.75 4.41413 8.41421 4.74992 8 4.74992C7.58579 4.74992 7.25 4.41413 7.25 3.99992V1.33325C7.25 0.919038 7.58579 0.583252 8 0.583252Z",
  fill: "#F2A56D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 11.25C8.41421 11.25 8.75 11.5858 8.75 12V14.6667C8.75 15.0809 8.41421 15.4167 8 15.4167C7.58579 15.4167 7.25 15.0809 7.25 14.6667V12C7.25 11.5858 7.58579 11.25 8 11.25Z",
  fill: "#F2A56D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.75634 2.75629C3.04923 2.4634 3.5241 2.4634 3.817 2.75629L5.70366 4.64296C5.99656 4.93585 5.99656 5.41072 5.70366 5.70362C5.41077 5.99651 4.9359 5.99651 4.643 5.70362L2.75634 3.81695C2.46344 3.52406 2.46344 3.04918 2.75634 2.75629Z",
  fill: "#F2A56D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2963 10.2963C10.5892 10.0034 11.0641 10.0034 11.357 10.2963L13.2437 12.183C13.5366 12.4759 13.5366 12.9508 13.2437 13.2437C12.9508 13.5365 12.4759 13.5365 12.183 13.2437L10.2963 11.357C10.0034 11.0641 10.0034 10.5892 10.2963 10.2963Z",
  fill: "#F2A56D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.583328 8C0.583328 7.58579 0.919115 7.25 1.33333 7.25H3.99999C4.41421 7.25 4.74999 7.58579 4.74999 8C4.74999 8.41421 4.41421 8.75 3.99999 8.75H1.33333C0.919115 8.75 0.583328 8.41421 0.583328 8Z",
  fill: "#F2A56D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 8C11.25 7.58579 11.5858 7.25 12 7.25H14.6667C15.0809 7.25 15.4167 7.58579 15.4167 8C15.4167 8.41421 15.0809 8.75 14.6667 8.75H12C11.5858 8.75 11.25 8.41421 11.25 8Z",
  fill: "#F2A56D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.70366 10.2963C5.99656 10.5892 5.99656 11.0641 5.70366 11.357L3.817 13.2437C3.5241 13.5365 3.04923 13.5365 2.75634 13.2437C2.46344 12.9508 2.46344 12.4759 2.75634 12.183L4.643 10.2963C4.9359 10.0034 5.41077 10.0034 5.70366 10.2963Z",
  fill: "#F2A56D"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2437 2.75629C13.5366 3.04918 13.5366 3.52406 13.2437 3.81695L11.357 5.70362C11.0641 5.99651 10.5892 5.99651 10.2963 5.70362C10.0034 5.41072 10.0034 4.93585 10.2963 4.64296L12.183 2.75629C12.4759 2.4634 12.9508 2.4634 13.2437 2.75629Z",
  fill: "#F2A56D"
});

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.936ea62f.svg";
export { ForwardRef as ReactComponent };